module.exports = __webpack_public_path__ + "static/img/1_2_4.f3ad0a12.jpg";